import * as Sentry from "@sentry/react-native";

import { env } from "~/env";

export const initSentry = () =>
  Sentry.init({
    dsn: env.EXPO_PUBLIC_SENTRY_DSN,
    debug: true, // If `true`, Sentry will try to print out useful debugging information if something goes wrong with sending the event. Set it to `false` in production
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
  });

export const wrapSentry = Sentry.wrap;
